/**
 * API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { CommentDto } from '../model/commentDto';
import { CreateCommentCommand } from '../model/createCommentCommand';
import { GetCommentSummariesQuery } from '../model/getCommentSummariesQuery';
import { GetCommentSummariesQueryResult } from '../model/getCommentSummariesQueryResult';
import { GetCommentThreadQueryResult } from '../model/getCommentThreadQueryResult';
import { GetFeedQueryResult } from '../model/getFeedQueryResult';
import { GetUnreadFeedCountQueryResult } from '../model/getUnreadFeedCountQueryResult';
import { InlineResponse404 } from '../model/inlineResponse404';
import { MarkCommentThreadReadCommand } from '../model/markCommentThreadReadCommand';
import { MarkFeedItemsReadCommand } from '../model/markFeedItemsReadCommand';
import { ReactionType } from '../model/reactionType';
import { ToggleFeedReactionResult } from '../model/toggleFeedReactionResult';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class FeedService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * [MOBILE] Gets a comment thread
     * Cursor-paginated comments for one activity within one group. Comments are private to the group&#x27;s members. Items come back newest-first; the client reverses for display and loads older pages upward via NextCursor.
     * @param sourceEventUid 
     * @param groupUid 
     * @param cursor 
     * @param limit 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public meFeedCommentsGet(sourceEventUid?: string, groupUid?: string, cursor?: string, limit?: number, observe?: 'body', reportProgress?: boolean): Observable<GetCommentThreadQueryResult>;
    public meFeedCommentsGet(sourceEventUid?: string, groupUid?: string, cursor?: string, limit?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetCommentThreadQueryResult>>;
    public meFeedCommentsGet(sourceEventUid?: string, groupUid?: string, cursor?: string, limit?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetCommentThreadQueryResult>>;
    public meFeedCommentsGet(sourceEventUid?: string, groupUid?: string, cursor?: string, limit?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {





        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (sourceEventUid !== undefined && sourceEventUid !== null) {
            queryParameters = queryParameters.set('sourceEventUid', <any>sourceEventUid);
        }
        if (groupUid !== undefined && groupUid !== null) {
            queryParameters = queryParameters.set('groupUid', <any>groupUid);
        }
        if (cursor !== undefined && cursor !== null) {
            queryParameters = queryParameters.set('cursor', <any>cursor);
        }
        if (limit !== undefined && limit !== null) {
            queryParameters = queryParameters.set('limit', <any>limit);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GetCommentThreadQueryResult>('get',`${this.basePath}/Me/Feed/comments`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [MOBILE] Posts a comment
     * Adds a comment to a (source event × group) thread. The caller must be a member of the group and the activity must have been shared to it. Broadcasts the new comment to the group over SignalR and pushes a notification to the activity author.
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public meFeedCommentsPost(body?: CreateCommentCommand, observe?: 'body', reportProgress?: boolean): Observable<CommentDto>;
    public meFeedCommentsPost(body?: CreateCommentCommand, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CommentDto>>;
    public meFeedCommentsPost(body?: CreateCommentCommand, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CommentDto>>;
    public meFeedCommentsPost(body?: CreateCommentCommand, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<CommentDto>('post',`${this.basePath}/Me/Feed/comments`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [MOBILE] Marks a comment thread read
     * Advances the caller&#x27;s read watermark for a (source event × group) thread, clearing the unread highlight. Pushes the updated counts to the caller&#x27;s other devices over SignalR.
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public meFeedCommentsReadPost(body?: MarkCommentThreadReadCommand, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public meFeedCommentsReadPost(body?: MarkCommentThreadReadCommand, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public meFeedCommentsReadPost(body?: MarkCommentThreadReadCommand, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public meFeedCommentsReadPost(body?: MarkCommentThreadReadCommand, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('post',`${this.basePath}/Me/Feed/comments/read`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [MOBILE] Gets comment counters for a batch of activities
     * Per source-event comment counts and unread flags, aggregated across the groups the caller belongs to. Batched so the feed issues one request for many visible cards. Activities with no visible comments are omitted.
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public meFeedCommentsSummariesPost(body?: GetCommentSummariesQuery, observe?: 'body', reportProgress?: boolean): Observable<GetCommentSummariesQueryResult>;
    public meFeedCommentsSummariesPost(body?: GetCommentSummariesQuery, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetCommentSummariesQueryResult>>;
    public meFeedCommentsSummariesPost(body?: GetCommentSummariesQuery, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetCommentSummariesQueryResult>>;
    public meFeedCommentsSummariesPost(body?: GetCommentSummariesQuery, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<GetCommentSummariesQueryResult>('post',`${this.basePath}/Me/Feed/comments/summaries`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [MOBILE] Deletes a comment
     * Soft-deletes the comment identified by Uid. Permitted for the author, the group admin, or the author of the underlying activity. Broadcasts the deletion to the group over SignalR.
     * @param uid 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public meFeedCommentsUidDelete(uid: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public meFeedCommentsUidDelete(uid: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public meFeedCommentsUidDelete(uid: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public meFeedCommentsUidDelete(uid: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (uid === null || uid === undefined) {
            throw new Error('Required parameter uid was null or undefined when calling meFeedCommentsUidDelete.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('delete',`${this.basePath}/Me/Feed/comments/${encodeURIComponent(String(uid))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [MOBILE] Gets the activity feed
     * Cursor-paginated activity feed. Category narrows the source set (mine / friends / org); groupUid further narrows when category is friends. Multi-group fanout collapses into a single card; per-(group × kind × day) buckets of three or more events collapse into a group digest.
     * @param cursor 
     * @param category 
     * @param groupUid 
     * @param limit 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public meFeedGet(cursor?: string, category?: string, groupUid?: string, limit?: number, observe?: 'body', reportProgress?: boolean): Observable<GetFeedQueryResult>;
    public meFeedGet(cursor?: string, category?: string, groupUid?: string, limit?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetFeedQueryResult>>;
    public meFeedGet(cursor?: string, category?: string, groupUid?: string, limit?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetFeedQueryResult>>;
    public meFeedGet(cursor?: string, category?: string, groupUid?: string, limit?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {





        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (cursor !== undefined && cursor !== null) {
            queryParameters = queryParameters.set('cursor', <any>cursor);
        }
        if (category !== undefined && category !== null) {
            queryParameters = queryParameters.set('category', <any>category);
        }
        if (groupUid !== undefined && groupUid !== null) {
            queryParameters = queryParameters.set('groupUid', <any>groupUid);
        }
        if (limit !== undefined && limit !== null) {
            queryParameters = queryParameters.set('limit', <any>limit);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GetFeedQueryResult>('get',`${this.basePath}/Me/Feed`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [MOBILE] Batch-marks feed items as read
     * Sets IsRead&#x3D;true for all listed FeedItem uids owned by the caller. Non-existent or already-read uids are ignored.
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public meFeedReadPost(body?: MarkFeedItemsReadCommand, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public meFeedReadPost(body?: MarkFeedItemsReadCommand, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public meFeedReadPost(body?: MarkFeedItemsReadCommand, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public meFeedReadPost(body?: MarkFeedItemsReadCommand, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('post',`${this.basePath}/Me/Feed/read`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [MOBILE] Dismisses a feed item
     * Hard-deletes the feed item identified by Uid. The caller must be the recipient of the item. Welcome card dismissal is permanent because User.WelcomeShownAtUtc remains set from the original write.
     * @param uid 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public meFeedUidDelete(uid: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public meFeedUidDelete(uid: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public meFeedUidDelete(uid: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public meFeedUidDelete(uid: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (uid === null || uid === undefined) {
            throw new Error('Required parameter uid was null or undefined when calling meFeedUidDelete.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('delete',`${this.basePath}/Me/Feed/${encodeURIComponent(String(uid))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [MOBILE] Toggles a reaction on a feed item
     * Toggles a reaction on the source activity event behind the feed item. Like / unlike converge on repeated calls. Rejects system + digest cards (no source event). Returns the post-toggle count + whether the caller liked.
     * @param uid 
     * @param type 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public meFeedUidReactionsTypePut(uid: string, type: ReactionType, observe?: 'body', reportProgress?: boolean): Observable<ToggleFeedReactionResult>;
    public meFeedUidReactionsTypePut(uid: string, type: ReactionType, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ToggleFeedReactionResult>>;
    public meFeedUidReactionsTypePut(uid: string, type: ReactionType, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ToggleFeedReactionResult>>;
    public meFeedUidReactionsTypePut(uid: string, type: ReactionType, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (uid === null || uid === undefined) {
            throw new Error('Required parameter uid was null or undefined when calling meFeedUidReactionsTypePut.');
        }

        if (type === null || type === undefined) {
            throw new Error('Required parameter type was null or undefined when calling meFeedUidReactionsTypePut.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ToggleFeedReactionResult>('put',`${this.basePath}/Me/Feed/${encodeURIComponent(String(uid))}/reactions/${encodeURIComponent(String(type))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [MOBILE] Gets the caller&#x27;s unread feed count
     * Number of FeedItems for the caller with IsRead&#x3D;false. Powers the Activity tab badge.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public meFeedUnreadCountGet(observe?: 'body', reportProgress?: boolean): Observable<GetUnreadFeedCountQueryResult>;
    public meFeedUnreadCountGet(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetUnreadFeedCountQueryResult>>;
    public meFeedUnreadCountGet(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetUnreadFeedCountQueryResult>>;
    public meFeedUnreadCountGet(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GetUnreadFeedCountQueryResult>('get',`${this.basePath}/Me/Feed/unread-count`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
